import ForgotPasswordView from "./ForgotPasswordView";

export const ForgotPasswordContainer = () => {
  return (
    <div>
      <ForgotPasswordView />
    </div>
  );
};
